import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { selectProdDataStatus } from 'features/cris/cris.slice';

/**
 * Triggers a callback whenever production data switch occurs.
 */
export const useCallbackOnProdSwitch = (onProdSwitch: () => void): void => {
    const showProd = useSelector(selectProdDataStatus);
    const callbackRef = useRef<() => void>();

    useEffect(() => {
        if (callbackRef.current !== onProdSwitch) {
            // run only when prod value switches, not the callback
            // this also suppresses the initial trigger and only results in being triggered on first change to showProd
            callbackRef.current = onProdSwitch;

            return;
        }
        onProdSwitch();
    }, [onProdSwitch, showProd]);
};
